/* tslint:disable */
/* eslint-disable */
/**
 * Pricing API
 * API for managing pricing.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FeesReferentialDto
 */
export interface FeesReferentialDto {
    /**
     * Nature remuneration code for the fee
     * @type {string}
     * @memberof FeesReferentialDto
     */
    code: string;
    /**
     * Decimal value of the fee
     * @type {number}
     * @memberof FeesReferentialDto
     */
    value: number;
}

/**
 * Check if a given object implements the FeesReferentialDto interface.
 */
export function instanceOfFeesReferentialDto(value: object): value is FeesReferentialDto {
    if (!('code' in value) || value['code'] === undefined) return false;
    if (!('value' in value) || value['value'] === undefined) return false;
    return true;
}

export function FeesReferentialDtoFromJSON(json: any): FeesReferentialDto {
    return FeesReferentialDtoFromJSONTyped(json, false);
}

export function FeesReferentialDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): FeesReferentialDto {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'],
        'value': json['value'],
    };
}

export function FeesReferentialDtoToJSON(json: any): FeesReferentialDto {
    return FeesReferentialDtoToJSONTyped(json, false);
}

export function FeesReferentialDtoToJSONTyped(value?: FeesReferentialDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'value': value['value'],
    };
}

